import { useAuth } from "@/contexts/auth-context";
import { Link } from "react-router-dom";

const footerLinks = {
  제품: [
    { label: "에이전트", href: "/agents" },
    { label: "프로젝트", href: "/projects" },
  ],
  법률: [
    { label: "개인정보 처리방침", href: "/privacy" },
    { label: "이용약관", href: "/terms" },
  ],
};

const Copyright = () => (
  <p className="text-body-sm text-black text-center leading-5 tracking-[-0.01em]">
    © 2026 PwC Consulting. All rights reserved.
  </p>
);

export const Footer = () => {
  const { isAuthenticated } = useAuth();

  return (
    <footer className="bg-[#EBEBEB] relative z-10">
      <div className="max-w-[1440px] mx-auto px-5 pt-10 pb-3 lg:px-[100px] lg:pt-12">
        <div className="flex flex-col gap-6 lg:flex-row lg:justify-between lg:items-center lg:gap-8 mb-6 lg:mb-8">
          <div className="lg:max-w-[353px] ">
            <div className="hidden lg:block mb-3">
              <img src="/images/logos/logo-footer-pc.svg" alt="PwC AI Agent Marketplace" />
            </div>
            {/* Mobile logo */}
            <div className="lg:hidden">
              <img src="/images/logos/footer-mobile.svg" alt="AI Agent Connect" />
            </div>
            <p className="text-body text-black leading-6 tracking-[-0.01em] whitespace-pre-line">
              {"Empowering businesses with AI intelligence\nfor a smarter future."}
            </p>
          </div>

          {/* Link columns */}
          <div className="flex gap-[100px] border-t border-white/[0.17] pt-6 lg:border-0 lg:pt-0">
            {Object.entries(footerLinks)
              .filter(([category]) => category !== "제품" || isAuthenticated)
              .map(([category, links]) => (
                <div key={category} className="flex flex-col gap-2">
                  <h4 className="text-h4 font-semibold text-black leading-6">{category}</h4>
                  <ul className="flex flex-col gap-1">
                    {links.map((link) => (
                      <li key={link.label}>
                        <Link
                          to={link.href}
                          className="text-body text-black leading-6 tracking-[-0.01em] transition-colors hover:underline"
                        >
                          {link.label}
                        </Link>
                      </li>
                    ))}
                  </ul>
                </div>
              ))}
          </div>
        </div>

        {/* Desktop copyright */}
        <div className="hidden lg:block border-t border-black/[0.12] pt-6">
          <Copyright />
        </div>
      </div>

      {/* Mobile copyright with separator bg */}
      <div className="lg:hidden bg-[#EBEBEB] py-3 px-5 border-t border-[#00000027]">
        <Copyright />
      </div>
    </footer>
  );
};
